/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CustomerSelection} from "./customerSelection.zod";
import {ExpedientEditableFields} from "./expedientEditableFields.zod";
import {RepresentativeSelection} from "./representativeSelection.zod";

export const CreateExpedientRequest = ExpedientEditableFields.and(
  zod.object({
    customer: CustomerSelection,
    representative: zod.union([RepresentativeSelection, zod.null()]).optional(),
  }),
);

export type CreateExpedientRequest = zod.input<typeof CreateExpedientRequest>;
export type CreateExpedientRequestOutput = zod.output<typeof CreateExpedientRequest>;
